(function () {
  'use strict';

  function initCollectionImageBanner(section) {
    if (!section || section.dataset.cibReady === 'true') {
      return;
    }

    section.dataset.cibReady = 'true';

    section.querySelectorAll('a[aria-disabled="true"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
      });
    });

    var images = section.querySelectorAll('.banner__media img');
    var remaining = images.length;

    function markReady() {
      section.classList.add('is-ready');
    }

    if (!remaining) {
      markReady();
      return;
    }

    images.forEach(function (image) {
      if (image.complete) {
        remaining -= 1;
        if (remaining <= 0) {
          markReady();
        }
        return;
      }

      function completeImage() {
        remaining -= 1;
        if (remaining <= 0) {
          markReady();
        }
      }

      image.addEventListener('load', completeImage, { once: true });
      image.addEventListener('error', completeImage, { once: true });
    });
  }

  function initAllCollectionImageBanners(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-cib-section]')) {
      initCollectionImageBanner(scope);
    }

    scope.querySelectorAll('[data-cib-section]').forEach(function (section) {
      initCollectionImageBanner(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCollectionImageBanners(document);
    });
  } else {
    initAllCollectionImageBanners(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllCollectionImageBanners(event.target);
  });
})();